export enum ExpenseState {
	WebEditing = 0,
	AdministrationEditing = 1,
	Refundable = 2,
	PartiallyRefundable = 3,
	NotRefundable = 4,
	IntegrateDocumentation = 5,
	IntegratedDocumentation = 6,
}
